import { useEffect, useRef } from "react";

/**
 * useInterval hook.
 *
 * Sets up an interval timer with a recurring task. Cleans up on unmount.
 *
 * @param {function} task Recurring task.
 * @param {int} delay Interval in milliseconds.
 *
 */

export const useInterval = (task, delay) => {
  const savedTask = useRef();

  // Remember the latest task.
  useEffect(() => {
    savedTask.current = task;
  }, [task]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedTask.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
